import { LookupKeys } from '@ag-common-lib/lib/models/crm/lookup.model';

export enum LineWidth {
  HalfScreen = '50%',
  FullScreen = '100%',
  Small = '20px',
}

export const LineWidthMap = new Map([
  [LineWidth.HalfScreen, 'Half Screen'],
  [LineWidth.FullScreen, 'Full Screen'],
  [LineWidth.Small, 'Small'],
]);

export const LINE_WIDTH_LOOKUP = [LineWidth.HalfScreen, LineWidth.FullScreen, LineWidth.Small].map(value => {
  return { [LookupKeys.value]: value, [LookupKeys.description]: LineWidthMap.get(value) };
});

export class SeparatorWidgetData {
  color: string = 'black';
  width: LineWidth = LineWidth.Small;
}
